import { InjectionToken } from '@angular/core';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils';

export const AJSAncillariesCommonsUtilService = new InjectionToken<CommonsUtilService>('CommonsUtilService');
export const AJSCommonsUtilServiceProvider = upgradeAJSServiceProvider('CommonsUtilService', AJSAncillariesCommonsUtilService);

export interface CommonsUtilServiceType extends CommonsUtilService {
    getIdItem(type: string): string;
    checkIsAddToCart(type: string): boolean;
}